/**
 * Converts a full weekday name to a short format (e.g., "Monday" to "Mon").
 * @param {string} weekDay - The full name of the weekday (e.g., "Monday").
 * @returns {string} The short format of the weekday (e.g., "Mon").
 */
export const toShortDay = (weekDay) => {
	return `${weekDay[0].toUpperCase()}${weekDay.slice(1, 3).toLowerCase()}`;
};
